import React, { useEffect } from 'react';
import TransportPageLayout from '../../components/transportation/TransportPageLayout';
import { ScheduleCard, RatesTable } from '../../components/transportation/TransportUI';
import { setSeoMetadata } from '../../lib/seo';

const ROUTE_LINKS = [
  { label: 'Route 107: Gifft Hill via Westin Resort – Inbound', href: 'https://dpw.vi.gov/stj-route-107-inbound/' },
  { label: 'Route 107: Gifft Hill via Westin Resort – Outbound', href: 'https://dpw.vi.gov/stj-route-107-outbound/' },
  { label: 'Route 108: Cruz Bay to Coral Bay – Inbound', href: 'https://dpw.vi.gov/stj-route-108-inbound/' },
  { label: 'Route 108: Cruz Bay to Coral Bay – Outbound', href: 'https://dpw.vi.gov/stj-route-108-outbound/' },
  { label: 'Route 109: Coral Bay to Cruz Bay – Inbound', href: 'https://dpw.vi.gov/stj-route-109-inbound/' },
  { label: 'Route 109: Coral Bay to Cruz Bay – Outbound', href: 'https://dpw.vi.gov/stj-route-109-outbound/' },
];

const PublicTransportationPage = () => {
  useEffect(() => {
    setSeoMetadata({
      title: 'Public Transportation St John | ViTran Bus | St John USVI',
      description:
        'The ViTran bus is an inexpensive way to get around St John, running from the Cruz Bay ferry dock along Centerline Road to Salt Pond Bay. Rates, routes and phone numbers.',
      keywords: 'vitran bus st john, public transportation st john, st john bus schedule, salt pond bus st john',
      canonicalPath: '/public-transportation-st-john',
      ogType: 'website',
    });
  }, []);

  return (
    <TransportPageLayout title="Public Transportation" subtitle="Around The Island" adId="public-transportation">
      <p className="text-center text-slate-700 leading-relaxed">
        The ViTran bus is an inexpensive option for the adventurous traveler. It travels between the Cruz Bay ferry
        dock along Centerline Road to Salt Pond Bay, with various stops along the way.{' '}
        <span className="font-semibold">The bus does not run on Saturdays</span> and does not go down the North Shore
        road.
      </p>

      <ScheduleCard
        title="ViTran Public Transportation"
        subtitle="Throughout St John"
        first
        testId="public-transport-vitran"
        operator={{ operatedBy: 'ViTran', phones: ['(340) 774-0165', '(340) 626-4010'], location: 'Throughout St John', travelTime: '30-35 minutes' }}
      >
        <RatesTable rates={[['Regular Fare', '$1.00'], ['Senior citizen (60+ / disability)', 'FREE'], ['Students (valid school ID)', '$0.75']]} />

        <div>
          <p className="mb-2 text-xs font-bold uppercase tracking-wide text-slate-500">St John Routes</p>
          <ul className="grid gap-2 sm:grid-cols-2" data-testid="public-transport-routes">
            {ROUTE_LINKS.map((r) => (
              <li key={r.href}>
                <a
                  href={r.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm font-semibold text-blue-700 hover:underline"
                >
                  {r.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <p className="text-xs text-slate-500">
          The bus picks up at 15 minutes past the hour at the Cruz Bay ferry dock, with the last pickup at 7:15 pm and
          the last stop at Salt Pond around 8 pm. Check with the driver for his return schedule. Information is
          subject to change without notice.
        </p>
      </ScheduleCard>
    </TransportPageLayout>
  );
};

export default PublicTransportationPage;
